import type { Feature } from '@luna/gatekeeper';

export const cardActivationFlowV2: Feature = {
    enabled: false,
};
